import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class SettleAgentComponent extends Component {
  SETTLE_AGENT = [
    [
      {
        name: "amount",
        label: "Amount",
        fieldType: "input",
        flexGrow: "10",
        inputType: "number"
      },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: "10",
      },
      { fieldType: "empty" }, { fieldType: "empty" }
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" },
    ]
  ];
  state = {
    settleAgentForm: new Form(
      {
        amount: "",
        notes: ""
      },
      [
        {
          name: "amount",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "notes",
          type: "isString",
          rules: {
            required: false,
          }
        }
      ]
    ),
  };

  onSaveDataEntries = () => {
    const { savedData, form, } = this.props;

    const isValid = form.isFormValid();
    this.saveValidationUpdate(form, isValid, isValid);

    if (isValid) {
      const data = {
        date: savedData.date.format("DD.MM.yyyy HH:mm"),
        value: form.amount,
        agentId: savedData.agent,
        notes: form.notes,
        currency: "USD",
      };

      crudActions.post(`v1/settlement/agent`, data)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : '');

        });
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const { settleAgentForm } = this.state;
    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);
    if (isFormValid) {
      this.updateState({
        settleAgentForm,
        lockButton: false,
        showSecondPanel: true,
        loadingDataInput: false
      });
      this.updateField(DATA_TYPES.SETTLE_AGENT, this.SETTLE_AGENT);
    }
  };
  
  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };

  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default SettleAgentComponent;